// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"4d5a4481","213":"2b6bcfd8","239":"4cd860a8","453":"419a5d54","455":"b10aeefd"}[chunkId] + ".chunk.js";
};